export enum ECommMatrixVerifyStatus {
  draft = 'draft',
  rework = 'rework',
  submitted = 'submitted',
  approved = 'approved',
  rejected = 'rejected',
  locked = 'locked',
}
